module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/modules/_library.js
// module id = 881
// module chunks = 0